document.addEventListener("change", function (e) {
  if (e.target.matches("[data-variant-select]")) {
    const select = e.target;
    const variantId = select.value;
    const price = select.options[select.selectedIndex].dataset.price;

    const form = select.closest(".product-card-form");
    form.querySelector("button.ajax-add-to-cart").setAttribute("data-id", variantId);
    const priceBox = select.closest(".card__content").querySelector("[data-card-price]");
    if (priceBox) priceBox.textContent = price;
  }
});

document.addEventListener("click", function(e){
  const btn = e.target.closest(".ajax-add-to-cart");
  if (!btn) return;
  e.preventDefault();

  const form = btn.closest("form");
  const variantId = btn.getAttribute("data-id");
  const qty = form.querySelector("[data-qty-input]") ? Number(form.querySelector("[data-qty-input]").value) : 1;

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(res => res.json())
  .then(data => {
    showPopup(`${data.title} added to cart!`);
    updateCartCount();
  })
  .catch(err => console.error("Cart Error:", err));
});

function showPopup(msg) {
  const popup = document.querySelector(".cart-popup");
  popup.innerHTML = `🛒 ${msg} <a href="/cart">View cart</a>`;
  popup.classList.add("show");
  setTimeout(() => popup.classList.remove("show"), 2000);
}

function updateCartCount(){
  fetch("/cart.js")
    .then(r => r.json())
    .then(cart => {
      // Update the visible number in the cart bubble
      const countBubble = document.querySelector(".cart-count-bubble span[aria-hidden='true']");
      if(countBubble) countBubble.innerText = cart.item_count;
      
      // Update visually-hidden text for accessibility
      const visuallyHidden = document.querySelector(".cart-count-bubble .visually-hidden");
      if(visuallyHidden) visuallyHidden.innerText = `${cart.item_count} items`;
    });
}
// Quantity buttons (+/-)
document.addEventListener("click", function(e){
  if(e.target.classList.contains("qty-plus") || e.target.classList.contains("qty-minus")){
    const box = e.target.closest(".qty-box");
    const input = box.querySelector(".qty-input");
    let value = parseInt(input.value);

    if(e.target.classList.contains("qty-plus")) value++;
    if(e.target.classList.contains("qty-minus")) value = Math.max(1, value - 1);

    input.value = value;
  }
});
